var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 32
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 3.333,
  d: "M40.336 4.629Zm-.003-.028-.018-.16c-.084-1.54-1.382-2.758-3.003-2.774-.109-.001-.22 0-.428.008l-.046.001c-.251.008-.366.011-.518.011H5.051c-.2 0-.288 0-.392.002-.43.007-.694.04-.905.114-1.291.442-2.087 1.54-2.087 2.862v22.51c0 .075.002.15.008.299.042.967.524 1.807 1.378 2.4.45.31 1.084.46 1.95.46h28.612c.506 0 .912-.002 1.823-.006a410 410 0 0 1 1.829-.005c1.377-.003 2.578-.87 2.946-2.128.097-.32.12-.633.12-1.442V4.601Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.613 10.667h10.873c.884 0 1.612.743 1.612 1.645v1.857l3.226-2.229c.26-.159.676 0 .676.372v7.323c0 .425-.416.584-.676.372l-3.226-2.23v1.911c0 .902-.728 1.645-1.612 1.645H13.613c-.885 0-1.613-.743-1.613-1.645v-7.376c0-.902.728-1.645 1.613-1.645m7.023 4.829-2.55-1.54c-.415-.211-.884.054-.884.532v3.024c0 .425.469.743.885.531l2.549-1.539c.364-.212.364-.796 0-1.008"
}))));
export { SvgVideoIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/video-icon.10052e9e.svg";